import React from "react";
// Import the same styles your real table uses
import styles from "./Table.module.css";

const TableSkeleton = ({ rows = 10 }) => {
  return (
    /* Use your existing tableWrapper to match padding/margins */
    <>
      <style>
        {`
          @keyframes shimmer {
            0% { background-position: -400px 0; }
            100% { background-position: 400px 0; }
          }

          .sk-base {
            background: #f2f4f7;
            background-image: linear-gradient(
              90deg, 
              #f2f4f7 0%, 
              #e2e8f0 20%, 
              #f2f4f7 40%, 
              #f2f4f7 100%
            );
            background-size: 800px 100%;
            animation: shimmer 1.5s infinite linear;
            border-radius: 4px;
            display: inline-block;
          }

          .sk-avatar { width: 35px; height: 35px; border-radius: 50%; flex-shrink: 0; }
          .sk-flex-row { display: flex; align-items: center; gap: 10px; }
          .sk-flex-col { display: flex; flex-direction: column; gap: 6px; }
          .sk-badge { width: 80px; height: 22px; border-radius: 15px; }
          .sk-action { width: 18px; height: 18px; border-radius: 3px; }

          /* Ensure td padding and border match your real table rows */
          .sk-tr td {
            padding: 14px 12px;
            border-bottom: 1px dashed #e0e0e0;
            vertical-align: middle;
          }
        `}
      </style>
      {[...Array(rows)].map((_, i) => (
        <tr key={i} className="sk-tr">
          {/* Column 1: Customer */}
          <td className={styles.nameCell}>
            <div className="sk-flex-row">
              <div className="sk-base sk-avatar"></div>
              <div className="sk-flex-col">
                <div
                  className="sk-base"
                  style={{ width: "110px", height: "13px" }}
                ></div>
                <div
                  className="sk-base"
                  style={{ width: "80px", height: "11px" }}
                ></div>
              </div>
            </div>
          </td>

          {/* Column 2: Mobile */}
          <td>
            <div className="sk-flex-col">
              <div className="sk-flex-row" style={{ gap: "5px" }}>
                <div
                  className="sk-base"
                  style={{ width: "12px", height: "12px" }}
                ></div>
                <div
                  className="sk-base"
                  style={{ width: "85px", height: "12px" }}
                ></div>
              </div>
              <div className="sk-flex-row" style={{ gap: "5px" }}>
                <div
                  className="sk-base"
                  style={{ width: "12px", height: "12px" }}
                ></div>
                <div
                  className="sk-base"
                  style={{ width: "85px", height: "12px" }}
                ></div>
              </div>
            </div>
          </td>

          {/* Column 3: Email */}
          <td>
            <div className="sk-flex-col">
              <div className="sk-flex-row" style={{ gap: "5px" }}>
                <div
                  className="sk-base"
                  style={{ width: "12px", height: "12px" }}
                ></div>
                <div
                  className="sk-base"
                  style={{ width: "130px", height: "12px" }}
                ></div>
              </div>
              <div
                className="sk-base"
                style={{ width: "12px", height: "12px" }}
              ></div>
            </div>
          </td>

          {/* Column 4: KYC Status */}
          <td>
            <div className="sk-base sk-badge"></div>
          </td>

          {/* Column 5: Login Status */}
          <td>
            <div className="sk-base sk-badge" style={{ width: "60px" }}></div>
          </td>

          {/* Column 6: Created On */}
          <td>
            <div className="sk-flex-row" style={{ gap: "5px" }}>
              <div
                className="sk-base"
                style={{ width: "14px", height: "14px" }}
              ></div>
              <div
                className="sk-base"
                style={{ width: "85px", height: "12px" }}
              ></div>
            </div>
          </td>

          {/* Column 7: Action */}
          <td align="center">
            <div className="sk-base sk-action"></div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default TableSkeleton;
